import React, { useMemo } from 'react';

import { Link } from '@this/src/components/shared/ui/navigations/link';

const TripChatHeader: React.FC = () => {
  const styles = useMemo(() => getStyles(), []);

  return (
    <div style={styles.header}>
      <Link href="/trips">&lt; 旅程管理一覧</Link>
    </div>
  );
};

const getStyles = () => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: 'solid 1px #eee',
    paddingTop: 10,
    paddingBottom: 10
  }
});

export default TripChatHeader;
